export default __webpack_public_path__ + "static/media/moto_shop.e4c4567d.svg";